import {z} from 'zod'

export const dateTimeSchema = z.object({
  dateTime: z.array(z.string().datetime())
})
